<footer>
  <div class="containero">
    <button *ngIf="prev || prevEvent" class="btn btn-primary nav-button-prev" (click)="onPrevClick(prev)">
      <div class="content"  >POWRÓT</div>
    </button>
    <button *ngIf="next || nextEvent" class="btn btn-success leaning nav-button nav-button-next btn-border-rev" [routerLink]="next"
      (click)="onNextClick(next)">
      <div class="content"  >DALEJ</div>
    </button>


  </div>



    <a mdbBtn floating="true"  class="waves-light" style="display: none">

    </a>




</footer>
